import { actionType } from "../../helpers/reducers";

export const READER_SET_THEME = "reader/setTheme";
export const READER_SET_FONT_SIZE = "reader/setFontSize";

export const setReaderTheme = actionType(READER_SET_THEME);
export const setReaderFontSize = actionType(READER_SET_FONT_SIZE);
